import { render, staticRenderFns } from "./StatementSubmited.vue?vue&type=template&id=23f923b8&scoped=true"
import script from "./StatementSubmited.vue?vue&type=script&lang=js"
export * from "./StatementSubmited.vue?vue&type=script&lang=js"
import style0 from "./StatementSubmited.vue?vue&type=style&index=0&id=23f923b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f923b8",
  null
  
)

export default component.exports